export const getCellEmphasis = (cellValueChanged: boolean) => {
    return cellValueChanged ? 'attention' : 'default';
};
